import React from 'react';
import { connect } from 'react-redux';

import { isSFTCabinetsGroup } from '../../../helpers/sqftNavigationHelper';
//import CustomSizeSwitcher from "./Attributes/CustomSizeSwitcher";
//import CustomSize from "./Attributes/CustomSize";
import Handles from "./Attributes/Handles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {FormattedMessage} from "react-intl";
import Hinges from "./Attributes/Hinges";
import workspaceControllers from "../../canvas/store/workspaceControllers";
import workspace from "../../canvas/core/workspace";
import {setFeaturePicker, setSQFTActiveShapeId} from "../../../../../actions/sqftMenuFunctions";
import SectionCustomBox from "./Attributes/SectionCustomBox";
import SectionCustomSize from "./Attributes/SectionCustomSize";
import SectionImage from "./Attributes/SectionImage";
import {FEATURES_WITH_DISABLED_RESIZING} from "../../../constants";
//import CabinetPreview from "./Attributes/CabinetPreview";
//import CustomSizeSwapButton from "./Attributes/CustomSizeSwapButton";

const SqftCabinetAttributes = (props) => {
  const {sqftActiveShapeId, setSQFTActiveShapeId, featurePicker, setFeaturePicker} = props;
  const isCabinet = isSFTCabinetsGroup();
  const shape = workspace.getShapeById(sqftActiveShapeId);

  if (!isCabinet || !sqftActiveShapeId) {
    if (featurePicker.isOpen) {
      setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
    }
    return null;
  }

  const handleClose = () => {
    setSQFTActiveShapeId(null);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  };

  const existingHinges = workspaceControllers.hinge.getAllResourcesForTheShape(sqftActiveShapeId);
  if (existingHinges.length) {
    void existingHinges
  }

  const featureName = shape.getFeature()?.getFeatureName();
  const isResizingEnabled = !FEATURES_WITH_DISABLED_RESIZING.includes(featureName);

  return (
    <div className="sr">
      <div className="sr__header">
        <span className="sr__title">
          <FormattedMessage id="attributes"/>
        </span>
        <IconButton aria-label={{}}
                    className="look-icon look-icon--super-tiny look-icon--gray5 sr__close-button"
                    onClick={ handleClose }>
          <CloseIcon className="close-icon"/>
        </IconButton>
      </div>

      <div className="sr__content">
        {/* Original Cabinet Image and Dimensions */}
        <SectionImage shape={shape} />

        {/* Enable Custom Size */}
        { isResizingEnabled ? <SectionCustomSize shape={shape} /> : null }

        {/* Add as custom box */}
        <SectionCustomBox shape={shape} />

        {/* Hinge Selection */}
        <Hinges/>

        {/* Handle Selection */}
        <Handles />

      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
  featurePicker: store.sqftMenuState.featurePicker
});

const mapDispatchToProps = {
  setSQFTActiveShapeId,
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftCabinetAttributes);
